module.exports = __webpack_public_path__ + "img/cs.f52b4d0b.svg";